import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


export function initScrollAnimations() {
  triggerLogoColor();
  animateBridgeWater();
  animateCta();
}

function triggerLogoColor() {
  const el = document.querySelector('.content');
  const logo = document.querySelector('.hero__nav__logo');
  const lang = document.querySelector('.hero__nav__lang')

  ScrollTrigger.create({
    trigger: el,
    start: 'top 15%',
    onEnter: () => { 
      logo.classList.remove('has-filter-white');
      lang.classList.add('has-text-blue');
    },
    onLeave: () => { 
      logo.classList.add('has-filter-white');
      lang.classList.remove('has-text-blue');
    },
    onEnterBack: () => { 
      logo.classList.remove('has-filter-white' );
      lang.classList.add('has-text-blue');
    },
    onLeaveBack: () => { 
      logo.classList.add('has-filter-white');
      lang.classList.remove('has-text-blue');
    }
  });
}

function animateBridgeWater() {
  gsap.to('.bridge__icon-water', {
    startAt: {x:'-50vw'}, 
    x: '50vw', 
    duration: 20, 
    ease: 'none', 
    repeat: -1}
  );
}

function animateCta() {
  const el = document.querySelector('.cta');

  // animate bridge
  const bridge = document.querySelector('.cta__icon-bridge');
  gsap.to(bridge, {
    scrollTrigger: {
      trigger: el,
      start: 'top 67%',
      end: 'center 80%',
      scrub: .5
    },
    width: '100%',
  });

  // animate water
  const water = document.querySelector('.cta__icon-water');
  gsap.to(water, {
    scrollTrigger: {
      trigger: el,
      start: 'top bottom'
    },
    startAt: {x:'-50vw'}, 
    x: '50vw', 
    duration: 20, 
    ease: 'none', 
    repeat: -1}
  );
}